export default "__VITE_ASSET__33f35de0__"